import { render, staticRenderFns } from "./medication-consent-section.vue?vue&type=template&id=0b850cc6&scoped=true"
import script from "./medication-consent-section.vue?vue&type=script&lang=js"
export * from "./medication-consent-section.vue?vue&type=script&lang=js"
import style0 from "./medication-consent-section.vue?vue&type=style&index=0&id=0b850cc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b850cc6",
  null
  
)

export default component.exports